/**
 * 匠人 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const partners = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list(params) {
        return axios.get(api + 'partners/list', { params: params })
    },
    // 待审列表
    reviewlist(params) {
        return axios.get(api + 'partners/reviewlist', { params: params })
    },
    // 审核
    review(params) {
        return axios.post(api + 'partners/review', qs.stringify(params))
    },
    detail(params) {
        return axios.get(api + 'partners/detail', { params: params })
    },
    remove(params) {
        return axios.post(api + 'partners/remove', qs.stringify(params))
    },
    edit(params) {
        return axios.post(api + 'partners/edit', qs.stringify(params))
    },
    // 分类列表
    cate(params) {
        return axios.get(api + 'partnerstype/catelist', { params: params })
    },
    // 技艺列表
    skill(params) {
        return axios.get(api + 'partnerstype/skilllist', { params: params })
    },
    reviewStatus(params) {
        return axios.post(api + 'partners/reviewStatus', qs.stringify(params))
    },
    // 3.代理商列表--废用
    agentlist(params) {
        return axios.get(api + 'partners/agentlist', { params: params })
    },
    // 未绑定合伙人的 代理商列表
    noBindAgents(params) {
        return axios.get(api + 'partners/agentnoBindAgents', { params: params })
    },
    agentCreate(params) {
        return axios.post(api + 'partners/agentcreate', qs.stringify(params))
    },
    // 4.商家列表
    agenttradesmanlist(params) {
        return axios.get(api + 'partners/tradesmanlist', { params: params })
    },
    // 2.提成记录
    tcrecord(params) {
        return axios.get(api + 'partners/tcrecord', { params: params })
    },
    // 9.获取提成详情
    recorddetail(params) {
        return axios.get(api + 'partners/recorddetail', { params: params })
    },

    // 4.商家列表
    trdList(params) {
        return axios.get(api + 'partners/tradlist', { params: params })
    },
    // 4.商家列表
    trdCreate(params) {
        return axios.post(api + 'partners/tradcreate', qs.stringify(params))
    },
    bili(params) {
        return axios.post(api + 'partners/setBili', qs.stringify(params))
    },
    // 删除商户
    tradesmanremove(params) {
        return axios.post(api + 'partners/tradesmanremove', qs.stringify(params))
    },
    //导出收入记录
    exportpartnersShouru(params) {
        return axios.post(api + 'export/partnerShouru', qs.stringify(params))
    },
}

// 导出接口
export default partners
